module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-01.09859f70.jpg";